import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";
import { TransitionHistory } from "./types";
import { GlobalState } from "../store";

const initialState: TransitionHistory = { creditSales: [], ticketSales: [] };

export const transactionHistory = createSlice({
  name: "transactionHistory",
  initialState,
  reducers: {
    setTransitionHistory: (state, action: PayloadAction<TransitionHistory>) => {
      state.creditSales = action.payload.creditSales;
      state.ticketSales = action.payload.ticketSales;
    },
  },
});

const selector = (s: GlobalState) => s.data.transactionHistory;

export const selectCreditSales = createSelector(selector, (s) => s.creditSales);

export const selectTicketSales = createSelector(selector, (s) => s.ticketSales);

export const { setTransitionHistory } = transactionHistory.actions;
export default transactionHistory.reducer;
